<template lang="pug">
  v-app.protected(id="app")
    //- div(:class="{'inicio': (!$route.path.includes('vivemas')), 'inicio-vivemas': ($route.path.includes('vivemas'))}")
    div.inicio
      header.box-main-header-formatter(v-if="!(($route.path === '/prestamos-vida' || $route.path.includes('/prestamos-vida/solicitud')) && $vuetify.breakpoint.smAndDown)")
        v-container
          article
            figure.inicio-logo
              img(src="../assets/logo.svg" alt="logo de interseguro")
          //- article.g-flex
            search(style="float: right;" v-if="!searchMobile && $route.path.includes('help-center')")
            //- .inicio-search.mr-4
              svg(width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg")
                path(d="M28.5435 28.5442C28.4783 28.6094 28.401 28.661 28.3159 28.6963C28.2308 28.7315 28.1396 28.7497 28.0475 28.7497C27.9554 28.7497 27.8642 28.7315 27.7791 28.6963C27.694 28.661 27.6167 28.6094 27.5516 28.5442L22.3454 23.3382C20.2881 25.1376 17.612 26.0671 14.8822 25.9302C12.1524 25.7933 9.58269 24.6009 7.7157 22.6047C5.84871 20.6085 4.83063 17.9648 4.87648 15.232C4.92233 12.4992 6.02852 9.89114 7.96142 7.95869C9.89432 6.02624 12.5026 4.92067 15.2355 4.87547C17.9683 4.83026 20.6117 5.84896 22.6075 7.71642C24.6033 9.58388 25.7951 12.1539 25.9313 14.8837C26.0675 17.6135 25.1374 20.2894 23.3375 22.3463L28.5435 27.5523C28.6086 27.6174 28.6603 27.6947 28.6956 27.7798C28.7309 27.865 28.749 27.9562 28.749 28.0483C28.749 28.1404 28.7309 28.2317 28.6956 28.3168C28.6603 28.4019 28.6086 28.4791 28.5435 28.5442ZM15.422 24.5409C17.2256 24.5409 18.9886 24.0061 20.4882 23.0041C21.9878 22.0021 23.1566 20.5779 23.8468 18.9117C24.537 17.2454 24.7176 15.4119 24.3657 13.643C24.0139 11.8741 23.1454 10.2492 21.8701 8.97394C20.5948 7.69863 18.9699 6.83014 17.201 6.47828C15.4321 6.12643 13.5986 6.30701 11.9324 6.9972C10.2661 7.68739 8.84192 8.85619 7.83992 10.3558C6.83792 11.8554 6.30311 13.6184 6.30311 15.422C6.30583 17.8396 7.26745 20.1575 8.97699 21.867C10.6865 23.5766 13.0044 24.5382 15.422 24.5409Z" fill="#0855C4")
              input(type="text" placeholder="Busca lo que necesites")
            //- .inicio-notificacion
              svg(width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg")
                path(d="M11.8125 3.6575C11.571 3.6575 11.375 3.4615 11.375 3.22V1.75C11.375 1.26787 10.9821 0.875 10.5 0.875C10.0179 0.875 9.625 1.26787 9.625 1.75V3.22C9.625 3.4615 9.429 3.6575 9.1875 3.6575C8.946 3.6575 8.75 3.46238 8.75 3.22V1.75C8.75 0.784875 9.53487 0 10.5 0C11.4651 0 12.25 0.784875 12.25 1.75V3.22C12.25 3.46238 12.054 3.6575 11.8125 3.6575Z" fill="#0855C4")
                path(d="M10.5 20.9995C8.81125 20.9995 7.4375 19.6258 7.4375 17.937C7.4375 17.6955 7.6335 17.4995 7.875 17.4995C8.1165 17.4995 8.3125 17.6955 8.3125 17.937C8.3125 19.1428 9.29425 20.1245 10.5 20.1245C11.7058 20.1245 12.6875 19.1428 12.6875 17.937C12.6875 17.6955 12.8835 17.4995 13.125 17.4995C13.3665 17.4995 13.5625 17.6955 13.5625 17.937C13.5625 19.6258 12.1888 20.9995 10.5 20.9995Z" fill="#0855C4")
                path(d="M17.9375 18.375H3.0625C2.33887 18.375 1.75 17.7861 1.75 17.0625C1.75 16.6784 1.91713 16.3153 2.20938 16.065C3.58838 14.8995 4.375 13.2038 4.375 11.4082V8.75C4.375 5.3725 7.1225 2.625 10.5 2.625C13.8775 2.625 16.625 5.3725 16.625 8.75V11.4082C16.625 13.2046 17.4116 14.8995 18.7836 16.0589C19.0829 16.3153 19.25 16.6784 19.25 17.0625C19.25 17.7861 18.662 18.375 17.9375 18.375ZM10.5 3.5C7.60462 3.5 5.25 5.85462 5.25 8.75V11.4082C5.25 13.4628 4.3505 15.4009 2.78162 16.7274C2.681 16.8131 2.625 16.9347 2.625 17.0625C2.625 17.304 2.821 17.5 3.0625 17.5H17.9375C18.179 17.5 18.375 17.304 18.375 17.0625C18.375 16.9347 18.319 16.8131 18.2219 16.73C16.6504 15.4009 15.75 13.4619 15.75 11.4082V8.75C15.75 5.85462 13.3954 3.5 10.5 3.5Z" fill="#0855C4")
      main
        // QUITANDO CLASES PARA CUANDO ES VIVE+
        div.inicio-main-content.box-inicio-main-formatter
          // QUITANDO MENU CUANDO ES VIVE+
          nav.menu-separator(v-show="($vuetify.breakpoint.mdAndUp && showMenu)")
          nav.menu.box-menu-formatter(v-show="($vuetify.breakpoint.mdAndUp && showMenu) || ($vuetify.breakpoint.smAndDown && showMenu)")
            //- .transition-all-3
            a.g-flex(@click="goHome($event)")
              svg(width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg")
                path(d="M18.333 18.4384H18.438V18.3334V8.37105V8.3116L18.387 8.28102L11.0537 3.88102L10.9997 3.84861L10.9457 3.88102L3.61232 8.28102L3.56135 8.3116V8.37105V18.3334V18.4384H3.66634H7.33301H7.438V18.3334V15.8125C7.438 14.8679 7.81324 13.962 8.48119 13.2941C9.14913 12.6261 10.0551 12.2509 10.9997 12.2509C11.9443 12.2509 12.8502 12.6261 13.5182 13.2941C14.1861 13.962 14.5614 14.8679 14.5614 15.8125V18.3334V18.4384H14.6663H18.333ZM11.8889 2.48899L11.9427 2.39931L11.8889 2.48899L19.2222 6.88899C19.4782 7.04255 19.69 7.25977 19.837 7.51949C19.9841 7.77921 20.0614 8.07258 20.0614 8.37105V18.3334C20.0614 18.7918 19.8793 19.2314 19.5551 19.5555C19.231 19.8796 18.7914 20.0617 18.333 20.0617H12.938V15.8125C12.938 15.2985 12.7338 14.8055 12.3703 14.4419C12.0068 14.0784 11.5138 13.8742 10.9997 13.8742C10.4856 13.8742 9.99258 14.0784 9.62907 14.4419C9.26557 14.8055 9.06135 15.2985 9.06135 15.8125V20.0617H3.66634C3.20796 20.0617 2.76835 19.8796 2.44422 19.5555C2.12009 19.2314 1.938 18.7918 1.938 18.3334V8.37105C1.938 8.07258 2.01528 7.77921 2.16233 7.51949C2.30938 7.25977 2.52118 7.04255 2.77711 6.88899L10.1104 2.48899C10.3791 2.32782 10.6864 2.24269 10.9997 2.24269C11.3129 2.24269 11.6203 2.32782 11.8889 2.48899Z" fill="#0855C4" stroke="#0855C4" stroke-width="0.209981")
              span Home
            a.g-flex(@click="goProfile($event)")
              svg(width="21" height="23" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg")
                path(d="M10.3069 10.5131C11.2928 10.5131 12.2565 10.2048 13.0761 9.6272C13.8958 9.04961 14.5347 8.22865 14.912 7.26814C15.2892 6.30763 15.3879 5.25071 15.1956 4.23104C15.0033 3.21137 14.5285 2.27475 13.8315 1.53961C13.1344 0.804469 12.2462 0.303834 11.2794 0.101009C10.3125 -0.101816 9.31027 0.00226791 8.39948 0.400124C7.4887 0.79798 6.71024 1.47172 6.16254 2.33615C5.61484 3.20059 5.32251 4.2169 5.32251 5.25655C5.32251 6.65067 5.84765 7.98768 6.78241 8.97348C7.71718 9.95927 8.98499 10.5131 10.3069 10.5131ZM10.3069 1.4336C11.0239 1.4336 11.7248 1.65782 12.3209 2.07789C12.917 2.49796 13.3817 3.09501 13.656 3.79356C13.9304 4.49211 14.0022 5.26078 13.8623 6.00236C13.7224 6.74394 13.3772 7.42513 12.8702 7.95978C12.3633 8.49443 11.7173 8.85852 11.0141 9.00603C10.311 9.15354 9.58208 9.07783 8.91969 8.78848C8.2573 8.49913 7.69115 8.00915 7.29283 7.38047C6.89451 6.75179 6.6819 6.01265 6.6819 5.25655C6.6819 4.24264 7.06382 3.27025 7.74365 2.55331C8.42347 1.83637 9.34552 1.4336 10.3069 1.4336Z" fill="#0855C4")
                path(d="M20.0142 19.575L19.7559 14.6514C19.7108 13.9786 19.4229 13.3497 18.9514 12.894C18.48 12.4383 17.8608 12.1905 17.2214 12.2015H3.80118C3.17003 12.1935 2.55914 12.4363 2.09006 12.8817C1.62098 13.3271 1.3281 13.9424 1.2697 14.6052L0.925323 19.5288C0.901149 19.8771 0.945863 20.2268 1.05663 20.5559C1.16739 20.8849 1.3418 21.1861 1.56877 21.4403C1.81108 21.7124 2.10386 21.929 2.42892 22.0767C2.75398 22.2244 3.10437 22.3 3.45831 22.2989H17.4781C17.8283 22.2998 18.175 22.2258 18.4972 22.0812C18.8194 21.9366 19.1104 21.7246 19.3526 21.4578C19.5795 21.2087 19.7553 20.9129 19.8691 20.589C19.983 20.2651 20.0323 19.92 20.0142 19.575ZM18.3648 20.4734C18.25 20.599 18.1122 20.6986 17.9598 20.7663C17.8074 20.8339 17.6435 20.8681 17.4781 20.8669H3.45831C3.29137 20.8681 3.12598 20.8331 2.97242 20.764C2.81885 20.695 2.68039 20.5933 2.56565 20.4655C2.46618 20.3552 2.38956 20.2244 2.34067 20.0812C2.29178 19.9381 2.27169 19.7858 2.28169 19.634L2.62456 14.7103C2.65702 14.4081 2.79602 14.1298 3.01398 13.9307C3.23193 13.7315 3.51292 13.626 3.80118 13.6351H17.2214C17.5131 13.6245 17.7976 13.7319 18.0167 13.9354C18.2357 14.1388 18.3727 14.4229 18.3995 14.7294L18.6563 19.6531C18.6637 19.8031 18.6416 19.9531 18.5914 20.0938C18.5412 20.2344 18.4641 20.3625 18.3648 20.4702V20.4734Z" fill="#0855C4")
              span Mi perfil
            a.g-flex(@click="showInsurances($event)")
              svg(width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg")
                path(d="M9.23716 21.3477C9.12196 21.3477 9.00753 21.3291 8.8984 21.2926C3.57099 19.5719 0.000819951 14.5122 0.000819951 8.71375V4.85779C-0.00747433 4.39533 0.140003 3.94327 0.420043 3.57278C0.700083 3.20228 1.09678 2.93439 1.54769 2.81128L9.23561 0L16.9251 2.81128C17.3777 2.93268 17.7765 3.19983 18.0583 3.57049C18.3402 3.94114 18.489 4.39413 18.4812 4.85779V8.71375C18.4812 14.5168 14.9033 19.5734 9.57592 21.2926C9.46672 21.3288 9.35234 21.3474 9.23716 21.3477ZM9.23716 1.46835L1.95606 4.12974L1.91584 4.13891C1.75917 4.18338 1.62196 4.2782 1.52588 4.40838C1.42979 4.53857 1.38032 4.6967 1.38527 4.85779V8.71375C1.38527 13.8851 4.53623 18.3896 9.23716 19.9543C13.9396 18.3896 17.0906 13.8851 17.0906 8.71375V4.85779C17.0955 4.6967 17.0461 4.53857 16.95 4.40838C16.8539 4.2782 16.7167 4.18338 16.56 4.13891L16.4796 4.11444L9.23716 1.46835Z" fill="#0855C4")
                path(d="M7.74688 13.1339L4.85425 10.4481L5.80866 9.4447L7.77937 11.2756L13.1764 6.60742L14.0937 7.64292L7.74688 13.1339Z" fill="#0855C4")
              span Mis seguros
            a.g-flex.box-menu-home-seguros(@click="showMoreInsurances($event)")
              svg(width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg")
                g(clip-path="url(#clip0)")
                  path(d="M10.7599 19.2973C10.7599 18.1388 9.82081 17.1997 8.66252 17.1997C7.50403 17.1997 6.56494 18.1388 6.56494 19.2971C6.56494 20.4556 7.50403 21.3947 8.66252 21.3947C9.82019 21.3934 10.7586 20.4552 10.7599 19.2973ZM7.3089 19.2973C7.3089 18.5496 7.91482 17.9437 8.66252 17.9437C9.41001 17.9437 10.0159 18.5496 10.0159 19.2971C10.0159 20.0448 9.41001 20.6507 8.66252 20.6507C7.91524 20.6499 7.30973 20.0444 7.3089 19.2973Z" fill="#0855C4" stroke="#0855C4" stroke-width="0.286957")
                  path(d="M16.4294 21.3947C17.5879 21.3949 18.527 20.4558 18.527 19.2973C18.5272 18.1388 17.5881 17.1997 16.4296 17.1997C15.2711 17.1997 14.332 18.1388 14.332 19.2973C14.3335 20.455 15.2715 21.3932 16.4294 21.3947ZM16.4294 17.9437C17.1769 17.9437 17.783 18.5496 17.783 19.2971C17.7832 20.0446 17.1771 20.6507 16.4296 20.6507C15.6821 20.6507 15.076 20.0448 15.076 19.2973C15.0768 18.5502 15.6823 17.9447 16.4294 17.9437Z" fill="#0855C4" stroke="#0855C4" stroke-width="0.286957")
                  path(d="M-0.584564 1.70052H1.68446C2.43112 1.69761 3.06776 2.24126 3.18151 2.9794L4.97768 14.3254C5.14727 15.4255 6.09631 16.2361 7.20955 16.2318H18.312C18.5173 16.2318 18.684 16.0651 18.684 15.8598C18.684 15.6543 18.5173 15.4878 18.312 15.4878H7.20955C6.46289 15.4907 5.82625 14.9469 5.7125 14.2089L5.40716 12.2799H16.778C17.7408 12.2795 18.5977 11.6696 18.9132 10.7602L21.0228 4.67157C21.0624 4.55782 21.0444 4.43203 20.9746 4.33384C20.9047 4.23587 20.7918 4.17754 20.6714 4.17754H4.12433L3.91634 2.86295C3.74675 1.76279 2.7977 0.952201 1.68446 0.95656H-0.584564C-0.790066 0.95656 -0.956543 1.12325 -0.956543 1.32854C-0.956543 1.53404 -0.790066 1.70052 -0.584564 1.70052ZM20.1487 4.9217L18.2103 10.5165C17.9986 11.1266 17.4238 11.5357 16.778 11.5359H5.28925L4.24202 4.9215L20.1487 4.9217Z" fill="#0855C4" stroke="#0855C4" stroke-width="0.478261")
                defs
                  clipPath(id="clip0")
                    rect(width="22" height="22" fill="white")
              span Más seguros
            a.g-flex(@click="goFormalities($event)")
              svg(width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg")
                path(d="M16.3476 21H2.65157C2.29269 21.0018 1.93717 20.9327 1.60668 20.7969C1.27619 20.6611 0.977651 20.4613 0.729259 20.2098C0.485887 19.9664 0.295941 19.6776 0.170922 19.3609C0.0459024 19.0441 -0.0115927 18.706 0.00193566 18.3671L0.616898 2.44584C0.644872 1.78391 0.937045 1.15853 1.43158 0.702063C1.92611 0.245595 2.58418 -0.00613226 3.26651 0.000168769H15.8556C16.5419 -0.00749803 17.2038 0.246315 17.6995 0.707138C18.1951 1.16796 18.485 1.79906 18.5068 2.46501L18.9987 18.3862C19.0096 18.7237 18.9501 19.0599 18.8238 19.3746C18.6976 19.6892 18.5071 19.9758 18.2638 20.2172C18.0153 20.4664 17.7175 20.6642 17.3882 20.7988C17.0588 20.9333 16.7049 21.0017 16.3476 21ZM3.26651 1.31956C2.93792 1.31421 2.62009 1.43325 2.38032 1.65145C2.14055 1.86965 1.99768 2.1699 1.98195 2.4886L1.37458 18.4098C1.36795 18.5705 1.39523 18.7308 1.45477 18.8809C1.5143 19.031 1.60484 19.1677 1.72078 19.2825C1.84224 19.405 1.98802 19.5022 2.14932 19.5684C2.31062 19.6345 2.48406 19.6682 2.65915 19.6673H16.3552C16.5295 19.6683 16.7021 19.6352 16.8628 19.5698C17.0236 19.5045 17.169 19.4082 17.2905 19.287C17.4065 19.1729 17.4972 19.037 17.5573 18.8877C17.6173 18.7384 17.6454 18.5788 17.6398 18.4187L17.1493 2.49743C17.1363 2.17665 16.9944 1.87359 16.754 1.65316C16.5136 1.43272 16.1939 1.31244 15.8632 1.31808L3.26651 1.31956Z" fill="#0855C4")
                path(d="M13.2985 4.85791H6.15741C5.78004 4.85791 5.47412 5.15492 5.47412 5.52129C5.47412 5.88767 5.78004 6.18468 6.15741 6.18468H13.2985C13.6759 6.18468 13.9818 5.88767 13.9818 5.52129C13.9818 5.15492 13.6759 4.85791 13.2985 4.85791Z" fill="#0855C4")
                path(d="M14.0214 7.8623H5.11444C4.73707 7.8623 4.43115 8.15931 4.43115 8.52569C4.43115 8.89207 4.73707 9.18907 5.11444 9.18907H14.0214C14.3988 9.18907 14.7047 8.89207 14.7047 8.52569C14.7047 8.15931 14.3988 7.8623 14.0214 7.8623Z" fill="#0855C4")
                path(d="M14.5029 11.0283H4.63324C4.25587 11.0283 3.94995 11.3253 3.94995 11.6917C3.94995 12.0581 4.25587 12.3551 4.63324 12.3551H14.5029C14.8803 12.3551 15.1862 12.0581 15.1862 11.6917C15.1862 11.3253 14.8803 11.0283 14.5029 11.0283Z" fill="#0855C4")
                path(d="M14.9618 15.3985H4.02922C3.83807 15.4078 3.65094 15.3432 3.50868 15.2189C3.36642 15.0946 3.28062 14.9207 3.27002 14.7351C3.28022 14.5495 3.36591 14.3753 3.50825 14.2509C3.6506 14.1266 3.83797 14.0621 4.02922 14.0717H14.9618C15.153 14.0621 15.3404 14.1266 15.4827 14.2509C15.6251 14.3753 15.7108 14.5495 15.721 14.7351C15.7108 14.9208 15.6251 15.095 15.4827 15.2193C15.3404 15.3437 15.153 15.4082 14.9618 15.3985Z" fill="#0855C4")
              span Mis solicitudes
            a.g-flex.box-menu-home(@click="goPagoCuotas($event)" v-if="flags.isAvailableForPayments")
              svg(width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg")
                path(d="M22.9601 14.4936L22.9985 1.57908C22.9993 1.29945 22.7852 1.07204 22.5203 1.07116L1.52118 1.00153C1.25624 1.00065 1.04078 1.22663 1.03995 1.50627L1.00151 14.4208C1.00068 14.7005 1.21478 14.9278 1.47972 14.9287L22.4788 14.9984C22.7438 14.9992 22.9592 14.7733 22.9601 14.4936Z" stroke="#0855C4" stroke-width="1.4" stroke-miterlimit="10")
                path(d="M22.9602 4.32422H1.01221V7.97977H22.9602V4.32422Z" stroke="#0855C4" stroke-width="1.4" stroke-miterlimit="10")
                path(d="M3.7395 11.2319H8.68643" stroke="#0855C4" stroke-width="1.4" stroke-miterlimit="10")
              span Mis pagos
            a.g-flex(@click="goPrestamos($event)" v-if="flags.isAvailableForLoans")
              svg(width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg")
                path(d="M22.9601 14.4936L22.9985 1.57908C22.9993 1.29945 22.7852 1.07204 22.5203 1.07116L1.52118 1.00153C1.25624 1.00065 1.04078 1.22663 1.03995 1.50627L1.00151 14.4208C1.00068 14.7005 1.21478 14.9278 1.47972 14.9287L22.4788 14.9984C22.7438 14.9992 22.9592 14.7733 22.9601 14.4936Z" stroke="#0855C4" stroke-width="1.4" stroke-miterlimit="10")
                path(d="M22.9602 4.32422H1.01221V7.97977H22.9602V4.32422Z" stroke="#0855C4" stroke-width="1.4" stroke-miterlimit="10")
                path(d="M3.7395 11.2319H8.68643" stroke="#0855C4" stroke-width="1.4" stroke-miterlimit="10")
              span Préstamos
            a.g-flex(@click="goPrestamoVida($event)" v-if="prestamosVidaHabilitado")
              svg(width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg")
                path(d="M22.9601 14.4936L22.9985 1.57908C22.9993 1.29945 22.7852 1.07204 22.5203 1.07116L1.52118 1.00153C1.25624 1.00065 1.04078 1.22663 1.03995 1.50627L1.00151 14.4208C1.00068 14.7005 1.21478 14.9278 1.47972 14.9287L22.4788 14.9984C22.7438 14.9992 22.9592 14.7733 22.9601 14.4936Z" stroke="#0855C4" stroke-width="1.4" stroke-miterlimit="10")
                path(d="M2 3.5 Q2 2 3.5 2" stroke="#0855C4" stroke-width="1.2" fill="none")
                path(d="M22 12.5 Q22 14 20.5 14" stroke="#0855C4" stroke-width="1.2" fill="none")
                text(x="12" y="10.5" text-anchor="middle" fill="#0855C4" font-family="Arial, sans-serif" font-size="6" font-weight="bold") S/
              span Préstamos
            a.g-flex.box-menu-home(@click="goToVivemas($event)" v-if="shouldShowViveMas")
              svg(width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg")
                path(d="M17.0129 19.5217H3.96628C3.52101 19.5247 3.0927 19.3511 2.77521 19.0389C2.45772 18.7267 2.27693 18.3013 2.27246 17.8561L2.83707 8.86475H18.2226L18.7138 17.8561C18.7089 18.3025 18.527 18.7286 18.2081 19.041C17.8892 19.3533 17.4593 19.5262 17.0129 19.5217V19.5217Z" stroke="#0855C4" stroke-width="1.27036" stroke-miterlimit="10")
                path(d="M19.1424 4.77148H1.77235C1.34593 4.77148 1.00024 5.11717 1.00024 5.54359V8.09278C1.00024 8.5192 1.34593 8.86487 1.77235 8.86487H19.1424C19.5688 8.86487 19.9145 8.5192 19.9145 8.09278V5.54359C19.9145 5.11717 19.5688 4.77148 19.1424 4.77148Z" stroke="#0855C4" stroke-width="1.27036" stroke-miterlimit="10")
                path(d="M10.7852 4.74759C10.3928 3.9275 11.5065 2.57809 13.2723 1.73118C15.0381 0.884274 16.787 0.864511 17.1808 1.6846C17.5746 2.50469 16.4595 3.8541 14.6937 4.701" stroke="#0855C4" stroke-width="1.27036" stroke-miterlimit="10")
                path(d="M10.6225 4.7024C11.029 3.85549 9.92658 2.48209 8.16077 1.63518C6.39497 0.788273 4.63199 0.788273 4.22689 1.63518C3.82178 2.48209 4.92417 3.85549 6.68998 4.7024" stroke="#0855C4" stroke-width="1.27036" stroke-miterlimit="10")
              span Vive +
            a.g-flex(v-if="showHelpCenter" @click="goToHelpCenter($event)")
              svg(width="12" height="21" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg")
                path(d="M6.00008 0.666626C2.77541 0.666626 0.166748 3.27529 0.166748 6.49996C0.166748 6.73202 0.258935 6.95458 0.42303 7.11868C0.587124 7.28277 0.809684 7.37496 1.04175 7.37496C1.27381 7.37496 1.49637 7.28277 1.66047 7.11868C1.82456 6.95458 1.91675 6.73202 1.91675 6.49996C1.91675 4.24129 3.74142 2.41663 6.00008 2.41663C8.25875 2.41663 10.0834 4.24129 10.0834 6.49996C10.0834 7.49396 9.82442 8.15663 9.46625 8.66996C9.08825 9.21013 8.57141 9.63013 7.94725 10.1073L7.78625 10.2298C6.60792 11.1258 5.12508 12.2528 5.12508 14.6666V14.9583C5.12508 15.1904 5.21727 15.4129 5.38136 15.577C5.54546 15.7411 5.76802 15.8333 6.00008 15.8333C6.23215 15.8333 6.45471 15.7411 6.6188 15.577C6.78289 15.4129 6.87508 15.1904 6.87508 14.9583V14.6666C6.87508 13.1301 7.70808 12.4931 8.95758 11.5376L9.01125 11.4968C9.62608 11.0266 10.3494 10.462 10.9012 9.67213C11.4729 8.85429 11.8334 7.84046 11.8334 6.49996C11.8334 3.27529 9.22475 0.666626 6.00008 0.666626ZM6.00008 20.5C6.3095 20.5 6.60625 20.377 6.82504 20.1583C7.04383 19.9395 7.16675 19.6427 7.16675 19.3333C7.16675 19.0239 7.04383 18.7271 6.82504 18.5083C6.60625 18.2895 6.3095 18.1666 6.00008 18.1666C5.69066 18.1666 5.39392 18.2895 5.17512 18.5083C4.95633 18.7271 4.83342 19.0239 4.83342 19.3333C4.83342 19.6427 4.95633 19.9395 5.17512 20.1583C5.39392 20.377 5.69066 20.5 6.00008 20.5Z" fill="#0855C4")
              span Centro Ayuda
            //- a.g-flex(@click="goToContactUs($event)")
              svg(width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg")
                path(d="M14.8891 23.3227C14.6269 23.3222 14.3651 23.3016 14.106 23.2612C5.11028 21.8633 -1.13657 13.4031 0.17396 4.39767C0.17396 4.37825 0.17396 4.35884 0.17396 4.33942L0.183658 4.27632C0.400894 2.95081 1.13214 1.76446 2.21868 0.974777C3.30522 0.18509 4.65936 -0.144202 5.9872 0.0583677H6.00985H6.04868C6.39809 0.112144 6.74086 0.2027 7.07123 0.32855C7.3046 0.416377 7.53118 0.521298 7.74913 0.64244C7.93345 0.742831 8.08944 0.888155 8.20258 1.06494C8.31572 1.24172 8.38235 1.44423 8.39631 1.65365L8.80889 8.08657C8.82278 8.29481 8.78413 8.5032 8.69649 8.69261C8.60885 8.88201 8.47504 9.04636 8.30733 9.17058C7.92301 9.45473 7.50099 9.68398 7.05343 9.85172C7.7342 11.9628 9.08499 13.7942 10.9009 15.068C11.2027 14.6882 11.5574 14.3536 11.9541 14.0746C12.1215 13.956 12.3157 13.8808 12.5193 13.8557C12.7229 13.8306 12.9295 13.8563 13.1207 13.9306L19.0763 16.2151C19.2664 16.2881 19.4358 16.4065 19.5697 16.5599C19.7036 16.7133 19.7981 16.897 19.8448 17.0952C19.9032 17.3464 19.9416 17.6017 19.9597 17.8589C20.0106 18.5561 19.9173 19.2564 19.6856 19.9159C19.4539 20.5755 19.0888 21.1802 18.613 21.6924C18.1372 22.2046 17.561 22.6133 16.9203 22.8929C16.2796 23.1726 15.5882 23.3172 14.8891 23.3178V23.3227ZM14.3536 21.6627C15.2627 21.8027 16.1902 21.5764 16.9327 21.0335C17.6752 20.4906 18.172 19.6753 18.3143 18.7666C18.3552 18.506 18.3655 18.2416 18.345 17.9786C18.3386 17.8702 18.3262 17.7621 18.3078 17.6551L12.7308 15.5145C12.366 15.8008 12.0637 16.1587 11.8425 16.5662L11.4413 17.3023L10.7197 16.8768C9.36287 16.0711 8.1816 15.0012 7.24586 13.7305C6.31011 12.4599 5.63894 11.0144 5.27208 9.47961L5.0747 8.65285L5.91116 8.49105C6.36472 8.40823 6.79678 8.2343 7.18123 7.97978L6.79457 1.96106C6.69911 1.91414 6.60365 1.87369 6.50981 1.8381C6.28335 1.75202 6.04856 1.68966 5.80923 1.65203H5.75098C4.84699 1.51228 3.92436 1.73456 3.1832 2.27067C2.44204 2.80677 1.94213 3.61347 1.7919 4.51577C1.7919 4.5271 1.7919 4.54166 1.7919 4.5546V4.58211V4.61608C0.599478 12.7527 6.24122 20.3991 14.3681 21.6611L14.3536 21.6627Z" fill="#0855C4")
              span Contáctanos
            a.g-flex.box-menu-home(@click="logout($event)")
              svg(width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg")
                path(d="M9.78913 18.5891C14.6432 18.5891 18.5783 14.6517 18.5783 9.79456C18.5783 4.93747 14.6432 1 9.78913 1C4.93503 1 1 4.93747 1 9.79456C1 14.6517 4.93503 18.5891 9.78913 18.5891Z" stroke="#0855C4" stroke-width="1.82382" stroke-miterlimit="10")
                path(d="M13.2664 6.69189L6.31445 13.7156" stroke="#0855C4" stroke-width="1.82382" stroke-miterlimit="10")
                path(d="M13.2423 13.7389L6.33716 6.66846" stroke="#0855C4" stroke-width="1.82382" stroke-miterlimit="10")
              span Cerrar Sesión
          // QUITANDO CLASES PARA CUANDO ES VIVE+
          //- div(:class="{'inicio-main-dash': (!$route.path.includes('vivemas'))}", v-show="($vuetify.breakpoint.mdAndUp && showMenu) || ($vuetify.breakpoint.smAndDown && !showMenu)")
          div.inicio-main-dash( v-show="($vuetify.breakpoint.mdAndUp && showMenu) || ($vuetify.breakpoint.smAndDown && !showMenu)")
            router-view
      .inicio-footer.d-flex(v-if="$vuetify.breakpoint.smAndDown")
        article(@click="perfilMobile()", :class="{'active-perfil-mobile': activePerfilMobile}")
          div
            svg(width="21" height="23" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg")
              path(d="M10.3069 10.5131C11.2928 10.5131 12.2565 10.2048 13.0761 9.6272C13.8958 9.04961 14.5347 8.22865 14.912 7.26814C15.2892 6.30763 15.3879 5.25071 15.1956 4.23104C15.0033 3.21137 14.5285 2.27475 13.8315 1.53961C13.1344 0.804469 12.2462 0.303834 11.2794 0.101009C10.3125 -0.101816 9.31027 0.00226791 8.39948 0.400124C7.4887 0.79798 6.71024 1.47172 6.16254 2.33615C5.61484 3.20059 5.32251 4.2169 5.32251 5.25655C5.32251 6.65067 5.84765 7.98768 6.78241 8.97348C7.71718 9.95927 8.98499 10.5131 10.3069 10.5131ZM10.3069 1.4336C11.0239 1.4336 11.7248 1.65782 12.3209 2.07789C12.917 2.49796 13.3817 3.09501 13.656 3.79356C13.9304 4.49211 14.0022 5.26078 13.8623 6.00236C13.7224 6.74394 13.3772 7.42513 12.8702 7.95978C12.3633 8.49443 11.7173 8.85852 11.0141 9.00603C10.311 9.15354 9.58208 9.07783 8.91969 8.78848C8.2573 8.49913 7.69115 8.00915 7.29283 7.38047C6.89451 6.75179 6.6819 6.01265 6.6819 5.25655C6.6819 4.24264 7.06382 3.27025 7.74365 2.55331C8.42347 1.83637 9.34552 1.4336 10.3069 1.4336Z" fill="#919191")
              path(d="M20.0142 19.575L19.7559 14.6514C19.7108 13.9786 19.4229 13.3497 18.9514 12.894C18.48 12.4383 17.8608 12.1905 17.2214 12.2015H3.80118C3.17003 12.1935 2.55914 12.4363 2.09006 12.8817C1.62098 13.3271 1.3281 13.9424 1.2697 14.6052L0.925323 19.5288C0.901149 19.8771 0.945863 20.2268 1.05663 20.5559C1.16739 20.8849 1.3418 21.1861 1.56877 21.4403C1.81108 21.7124 2.10386 21.929 2.42892 22.0767C2.75398 22.2244 3.10437 22.3 3.45831 22.2989H17.4781C17.8283 22.2998 18.175 22.2258 18.4972 22.0812C18.8194 21.9366 19.1104 21.7246 19.3526 21.4578C19.5795 21.2087 19.7553 20.9129 19.8691 20.589C19.983 20.2651 20.0323 19.92 20.0142 19.575ZM18.3648 20.4734C18.25 20.599 18.1122 20.6986 17.9598 20.7663C17.8074 20.8339 17.6435 20.8681 17.4781 20.8669H3.45831C3.29137 20.8681 3.12598 20.8331 2.97242 20.764C2.81885 20.695 2.68039 20.5933 2.56565 20.4655C2.46618 20.3552 2.38956 20.2244 2.34067 20.0812C2.29178 19.9381 2.27169 19.7858 2.28169 19.634L2.62456 14.7103C2.65702 14.4081 2.79602 14.1298 3.01398 13.9307C3.23193 13.7315 3.51292 13.626 3.80118 13.6351H17.2214C17.5131 13.6245 17.7976 13.7319 18.0167 13.9354C18.2357 14.1388 18.3727 14.4229 18.3995 14.7294L18.6563 19.6531C18.6637 19.8031 18.6416 19.9531 18.5914 20.0938C18.5412 20.2344 18.4641 20.3625 18.3648 20.4702V20.4734Z" fill="#919191")
  
          p Perfil
        article(@click="inicioMobile()", :class="{'active-inicio-mobile': activeInicioMobile}")
          div
            svg(width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg")
              path(d="M18.333 18.4384H18.438V18.3334V8.37105V8.3116L18.387 8.28102L11.0537 3.88102L10.9997 3.84861L10.9457 3.88102L3.61232 8.28102L3.56135 8.3116V8.37105V18.3334V18.4384H3.66634H7.33301H7.438V18.3334V15.8125C7.438 14.8679 7.81324 13.962 8.48119 13.2941C9.14913 12.6261 10.0551 12.2509 10.9997 12.2509C11.9443 12.2509 12.8502 12.6261 13.5182 13.2941C14.1861 13.962 14.5614 14.8679 14.5614 15.8125V18.3334V18.4384H14.6663H18.333ZM11.8889 2.48899L11.9427 2.39931L11.8889 2.48899L19.2222 6.88899C19.4782 7.04255 19.69 7.25977 19.837 7.51949C19.9841 7.77921 20.0614 8.07258 20.0614 8.37105V18.3334C20.0614 18.7918 19.8793 19.2314 19.5551 19.5555C19.231 19.8796 18.7914 20.0617 18.333 20.0617H12.938V15.8125C12.938 15.2985 12.7338 14.8055 12.3703 14.4419C12.0068 14.0784 11.5138 13.8742 10.9997 13.8742C10.4856 13.8742 9.99258 14.0784 9.62907 14.4419C9.26557 14.8055 9.06135 15.2985 9.06135 15.8125V20.0617H3.66634C3.20796 20.0617 2.76835 19.8796 2.44422 19.5555C2.12009 19.2314 1.938 18.7918 1.938 18.3334V8.37105C1.938 8.07258 2.01528 7.77921 2.16233 7.51949C2.30938 7.25977 2.52118 7.04255 2.77711 6.88899L10.1104 2.48899C10.3791 2.32782 10.6864 2.24269 10.9997 2.24269C11.3129 2.24269 11.6203 2.32782 11.8889 2.48899Z" fill="#919191" stroke="#919191" stroke-width="0.209981")
          p Inicio
        article(@click="verMasMobile()", :class="{'active-mas-mobile': activeMasMobile}")
          div
            svg(width="36" height="10" viewBox="0 0 36 10" fill="none" xmlns="http://www.w3.org/2000/svg")
              circle(cx="5" cy="5" r="4.1" stroke="#919191" stroke-width="1.8")
              circle(cx="18" cy="5" r="4.1" stroke="#919191" stroke-width="1.8")
              circle(cx="31" cy="5" r="4.1" stroke="#919191" stroke-width="1.8")
          p Más
    //- LOADER PROCESS
    v-dialog(v-model="loader" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | Cerrando Sesión...
          v-progress-linear.mb-0(indeterminate="" color="white")
    PopupNps
    PopupSolicitudEnCurso(
      :openPopup="showModalSolicitudEnCurso"
      @close="showModalSolicitudEnCurso = false"
    )
  </template>
  
  <script>
  import { mapActions, mapGetters } from 'vuex'
  import Profile from '@/pages/Profile'
  import PopupNps from '@/components/modals/nps/PopupNps'
  import PopupSolicitudEnCurso from '@/components/modals/prestamos-vida/PopupSolicitudEnCurso.vue'
  
  export default {
    name: 'Protected',
    data () {
      return {
        loader: false,
        message: '',
        interval: null,
        showProfile: false,
        showModalSolicitudEnCurso: false,
        icon: require('./../assets/icons/icon-mi-perfil-principal.svg'),
        iconPerfilDesktop: require('./../assets/icons/icon-mis-seguros-perfil-desktop.svg'),
        iconEmergency: require('./../assets/icons/icon-emergencia.svg'),
        iconHome: require('./../assets/icons/icon-inicio-selected.svg'),
        iconProfile: require('./../assets/icons/icon-profile.svg'),
        iconContactCorreo: require('./../assets/icons/icon-contact-correo.svg'),
        iconContactTelefono: require('./../assets/icons/icon-contact-telefono.svg'),
        iconContactUbicacion: require('./../assets/icons/icon-contact-ubicacion.svg'),
        iconViewPolicy: require('./../assets/icons-info-policies/resource-33.svg'),
        iconViewPersonalPolicy: require('./../assets/icons-info-policies/resource-30.svg'),
        activeInicioMobile: false,
        activePerfilMobile: false,
        activeMasMobile: false,
        showHelpCenter: false,
        showMenu: false,
        flags: {
          isAvailableForPayments: false,
          isAvailableForLoans: false,
          isOnlySOAT: false
        },
        amplitude: {
          events: {
            funcionalitySelected: 'Funcionalidad Seleccionada',
            loanIntention: 'Intención de Préstamo'
          },
          properties: {
            myInsurance: 'Mis Seguros',
            profile: 'Mi Perfil',
            vivemas: 'Vive+',
            loans: 'Prestamos',
            formalities: 'Mis Solicitudes',
            moreInsurance: 'Más Seguros',
            cvc: 'Mis Pagos',
            emergency: 'Emergencias',
            contactUs: 'Contáctanos'
          }
        }
      }
    },
    beforeRouteEnter (to, from, next) {
      let local = JSON.parse(localStorage.getItem('jwt'))
      // if (from.path === '/')
      if (local.user.exp !== null && local.user.exp < Date.now()) {
        localStorage.setItem('outoftime', true)
        localStorage.removeItem('jwt')
        localStorage.removeItem('selPol')
        next('/')
      } else {
        next()
      }
    },
    methods: {
      ...mapActions('user', ['setEstadoPrestamo', 'tmpCheckJWT','inactiveJwtLogout']),
      resetTaggeoNps () {
        this.$store.dispatch('nps/updateEventLogNps', {
          datos: {
            ...this.$store.state.nps.taggeoNps.datos,
            'numeroPoliza': null,
            'productoConsultado': null,
            'subproductoConsultado': null
          }
        })
      },
      perfilMobile () {
        this.activeInicioMobile = false
        this.activeMasMobile = false
        this.activePerfilMobile = true
        // FOR AVOID ERROR IN REDUDANT PATH
        if (this.$route.path !== '/mi-perfil') { this.$router.push('/mi-perfil') }
      },
      inicioMobile () {
        this.activeMasMobile = false
        this.activePerfilMobile = false
        this.activeInicioMobile = true
        // FOR AVOID ERROR IN REDUDANT PATH
        if (this.$route.path !== '/inicio') { this.$router.push('/inicio') }
      },
      verMasMobile () {
        this.showMenu = !this.showMenu
        this.activeInicioMobile = false
        this.activePerfilMobile = false
        this.activeMasMobile = true
      },
      goHome (evt) {
        this.resetTaggeoNps()
        // EVENT TRACK - Universal Analytics
        this.$gtm.trackEvent({
          event: 'virtualEvent',
          category: 'Zona Segura',
          action: 'Seleccionar menú - Home',
          label: 'Home'
        })
        // EVENT TRACK - GA4
        this.$gtm.trackEvent({
          event: 'select_button',
          'Nombre Sección': 'Zona Segura',
          TipoElemento: 'Botón',
          TipoAccion: 'Seleccionar menú - Home',
          CTA: 'Home'
        })
        var allElements = document.querySelectorAll('.inicio-main-content nav.menu a')
        // REMOVE CLASSES IN MENU
        for (var i = 0; i < allElements.length; i++) {
          allElements[i].classList.remove('active-menu')
        }
        // ADD CLASS FOR ITEM SELECTED
        if (evt.target.nodeName === 'A') {
          evt.target.classList.add('active-menu')
        } else {
          evt.target.parentElement.classList.add('active-menu')
        }
        // CERRAR EL MENU CUANDO HACES CLICK
        if (this.$vuetify.breakpoint.smAndDown) {
          this.showMenu = !this.showMenu
        }
        // FOR AVOID ERROR IN REDUDANT PATH
        if (this.$route.path !== '/inicio') { this.$router.push('/inicio') }
      },
      goProfile (evt) {
        this.resetTaggeoNps()
        // EVENT TRACK - Universal Analytics
        this.$gtm.trackEvent({
          event: 'virtualEvent',
          category: 'Zona Segura',
          action: 'Seleccionar menú - Mi perfil',
          label: 'Mi perfil'
        })
        // EVENT TRACK - GA4
        this.$gtm.trackEvent({
          event: 'select_button',
          'Nombre Sección': 'Zona Segura',
          TipoElemento: 'Botón',
          TipoAccion: 'Seleccionar menú - Mi perfil', 
          CTA: 'Mi perfil'
        })
        var allElements = document.querySelectorAll('.inicio-main-content nav.menu a')
        for (var i = 0; i < allElements.length; i++) {
          allElements[i].classList.remove('active-menu')
        }
        if (evt.target.nodeName === 'A') {
          evt.target.classList.add('active-menu')
        } else {
          evt.target.parentElement.classList.add('active-menu')
        }
        // CERRAR EL MENU CUANDO HACES CLICK
        if (this.$vuetify.breakpoint.smAndDown) {
          this.showMenu = !this.showMenu
        }
        // TRACK EVENT - AMPLITUDE
        this.$amplitude.getInstance()
          .logEvent(
            this.amplitude.events.funcionalitySelected,
            {
              'Funcionalidad': this.amplitude.properties.profile
            }
          )
        // FOR AVOID ERROR IN REDUDANT PATH
        if (this.$route.path !== '/mi-perfil') { this.$router.push('/mi-perfil') }
      },
      showInsurances (evt) {
        this.resetTaggeoNps()
        // EVENT TRACK - Universal Analytics
        this.$gtm.trackEvent({
          event: 'virtualEvent',
          category: 'Zona Segura',
          action: 'Seleccionar menú - Mis seguros',
          label: 'Mis seguros'
        })
        // EVENT TRACK - GA4
        this.$gtm.trackEvent({
          event: 'select_button',
          'Nombre Sección': 'Zona Segura',
          TipoElemento: 'Botón',
          TipoAccion: 'Seleccionar menú - Mis seguros',
          CTA: 'Mis seguros'
        })
        var allElements = document.querySelectorAll('.inicio-main-content nav.menu a')
        for (var i = 0; i < allElements.length; i++) {
          allElements[i].classList.remove('active-menu')
        }
        if (evt.target.nodeName === 'A') {
          evt.target.classList.add('active-menu')
        } else {
          evt.target.parentElement.classList.add('active-menu')
        }
        // CERRAR EL MENU CUANDO HACES CLICK
        if (this.$vuetify.breakpoint.smAndDown) {
          this.showMenu = !this.showMenu
        }
        // TRACK EVENT - AMPLITUDE
        this.$amplitude.getInstance()
          .logEvent(
            this.amplitude.events.funcionalitySelected,
            {
              'Funcionalidad': this.amplitude.properties.myInsurance
            }
          )
        if (this.$route.path !== '/mi-seguros') { this.$router.push('/mis-seguros') }
      },
      showMoreInsurances (evt) {
        this.resetTaggeoNps()
        // EVENT TRACK - Universal Analytics
        this.$gtm.trackEvent({
          event: 'virtualEvent',
          category: 'Zona Segura',
          action: 'Seleccionar menú - Mas seguros',
          label: 'Mas seguros'
        })
        // EVENT TRACK - GA4
        this.$gtm.trackEvent({
          event: 'select_button',
          'Nombre Sección': 'Zona Segura',
          TipoElemento: 'Botón',
          TipoAccion: 'Seleccionar menú - Mas seguros',
          CTA: 'Mas seguros'
        })
        var allElements = document.querySelectorAll('.inicio-main-content nav.menu a')
        for (var i = 0; i < allElements.length; i++) {
          allElements[i].classList.remove('active-menu')
        }
        if (evt.target.nodeName === 'A') {
          evt.target.classList.add('active-menu')
        } else {
          evt.target.parentElement.classList.add('active-menu')
        }
        // CERRAR EL MENU CUANDO HACES CLICK
        if (this.$vuetify.breakpoint.smAndDown) {
          this.showMenu = !this.showMenu
        }
        // TRACK EVENT - AMPLITUDE
        this.$amplitude.getInstance()
          .logEvent(
            this.amplitude.events.funcionalitySelected,
            {
              'Funcionalidad': this.amplitude.properties.moreInsurance
            }
          )
        // FOR AVOID ERROR IN REDUDANT PATH
        if (this.$route.path !== '/mas-seguros') { this.$router.push('/mas-seguros') }
      },
      goPagoCuotas (evt) {
        this.resetTaggeoNps()
        // EVENT TRACK - Universal Analytics
        this.$gtm.trackEvent({
          event: 'virtualEvent',
          category: 'Zona Segura',
          action: 'Seleccionar menú - Mis pagos',
          label: 'Mis pagos'
        })
        // EVENT TRACK - GA4
        this.$gtm.trackEvent({
          event: 'select_button',
          'Nombre Sección': 'Zona Segura',
          TipoElemento: 'Botón',
          TipoAccion: 'Seleccionar menú - Mis pagos',
          CTA: 'Mis pagos'
        })
        var allElements = document.querySelectorAll('.inicio-main-content nav.menu a')
        for (var i = 0; i < allElements.length; i++) {
          allElements[i].classList.remove('active-menu')
        }
        if (evt.target.nodeName === 'A') {
          evt.target.classList.add('active-menu')
        } else {
          evt.target.parentElement.classList.add('active-menu')
        }
        if (this.polizasInfo !== null) {
          localStorage.setItem('paymentSuccess', '0')
          // TRACK EVENT - AMPLITUDE
          this.$amplitude.getInstance()
            .logEvent(
              this.amplitude.events.funcionalitySelected,
              {
                'Funcionalidad': this.amplitude.properties.cvc
              }
            )
          // CERRAR EL MENU CUANDO HACES CLICK
          if (this.$vuetify.breakpoint.smAndDown) {
            this.showMenu = !this.showMenu
          }
          // FOR AVOID ERROR IN REDUDANT PATH
          if (this.$route.path !== '/pago-de-cuotas') { this.$router.push('/pago-de-cuotas') }
        } else {
          this.$swal({
            title: 'Estimado Cliente',
            text: 'Estamos validando su información. Por favor, vuelva a ingresar a la opción.',
            type: 'warning',
            confirmButtonText: 'Entendido'
          })
        }
      },
      goPrestamos (evt) {
        this.resetTaggeoNps()
        // EVENT TRACK - Universal Analytics
        this.$gtm.trackEvent({
          event: 'virtualEvent',
          category: 'Zona Segura',
          action: 'Seleccionar menú - Mis préstamos',
          label: 'Mis préstamos'
        })
        // EVENT TRACK - GA4
        this.$gtm.trackEvent({
          event: 'select_button',
          'Nombre Sección': 'Zona Segura',
          TipoElemento: 'Botón',
          TipoAccion: 'Seleccionar menú - Mis préstamos',
          CTA: 'Mis préstamos'
        })
        var allElements = document.querySelectorAll('.inicio-main-content nav.menu a')
        for (var i = 0; i < allElements.length; i++) {
          allElements[i].classList.remove('active-menu')
        }
        if (evt.target.nodeName === 'A') {
          evt.target.classList.add('active-menu')
        } else {
          evt.target.parentElement.classList.add('active-menu')
        }
        if (this.polizasInfo !== null) {
          localStorage.setItem('paymentSuccess', '0')
          // TRACK EVENT - AMPLITUDE
          this.$amplitude.getInstance()
            .logEvent(
              this.amplitude.events.funcionalitySelected,
              {
                'Funcionalidad': 'Prestamos'
              }
            )
          // CERRAR EL MENU CUANDO HACES CLICK
          if (this.$vuetify.breakpoint.smAndDown) {
            this.showMenu = !this.showMenu
          }
          // FOR AVOID ERROR IN REDUDANT PATH
          if (this.$route.path !== '/prestamos/operaciones') { this.$router.push('/prestamos/operaciones') }
        } else {
          this.$swal({
            title: 'Estimado Cliente',
            text: 'Estamos validando su información. Por favor, vuelva a ingresar a la opción.',
            type: 'warning',
            confirmButtonText: 'Entendido'
          })
        }
      },
      goPrestamoVida (evt) {
        this.resetTaggeoNps()
        // EVENT TRACK - Universal Analytics
        this.$gtm.trackEvent({
          event: 'virtualEvent',
          category: 'Zona Segura',
          action: 'Seleccionar menú - Prestamo Vida',
          label: 'Prestamo Vida'
        })
        // EVENT TRACK - GA4
        this.$gtm.trackEvent({
          event: 'select_button',
          'Nombre Sección': 'Zona Segura',
          TipoElemento: 'Botón',
          TipoAccion: 'Seleccionar menú - Prestamo Vida',
          CTA: 'Prestamo Vida'
        })
        var allElements = document.querySelectorAll('.inicio-main-content nav.menu a')
        for (var i = 0; i < allElements.length; i++) {
          allElements[i].classList.remove('active-menu')
        }
        if (evt.target.nodeName === 'A') {
          evt.target.classList.add('active-menu')
        } else {
          evt.target.parentElement.classList.add('active-menu')
        }
        if (this.tieneSolicitudPrestamoVidaEnEvaluacion) {
          this.showModalSolicitudEnCurso = true
          return
        }
        if (this.polizasInfo !== null) {
          // CERRAR EL MENU CUANDO HACES CLICK
          if (this.$vuetify.breakpoint.smAndDown) {
            this.showMenu = false
          }
          // FOR AVOID ERROR IN REDUDANT PATH
          if (this.$route.path !== '/prestamos-vida') { this.$router.push('/prestamos-vida') }
        } else {
          this.$swal({
            title: 'Estimado Cliente',
            text: 'Estamos validando su información. Por favor, vuelva a ingresar a la opción.',
            type: 'warning',
            confirmButtonText: 'Entendido'
          })
        }
      },
      goFormalities (evt) {
        this.resetTaggeoNps()
        // EVENT TRACK - Universal Analytics
        this.$gtm.trackEvent({
          event: 'virtualEvent',
          category: 'Zona Segura',
          action: 'Seleccionar menú - Mis solicitudes',
          label: 'Mis solicitudes'
        })
        // EVENT TRACK - GA4
        this.$gtm.trackEvent({
          event: 'select_button',
          'Nombre Sección': 'Zona Segura',
          TipoElemento: 'Botón',
          TipoAccion: 'Seleccionar menú - Mis solicitudes',
          CTA: 'Mis solicitudes'
        })
        var allElements = document.querySelectorAll('.inicio-main-content nav.menu a')
        for (var i = 0; i < allElements.length; i++) {
          allElements[i].classList.remove('active-menu')
        }
        if (evt.target.nodeName === 'A') {
          evt.target.classList.add('active-menu')
        } else {
          evt.target.parentElement.classList.add('active-menu')
        }
        // TRACK EVENT - AMPLITUDE
        this.$amplitude.getInstance()
          .logEvent(
            this.amplitude.events.funcionalitySelected,
            {
              'Funcionalidad': this.amplitude.properties.formalities
            }
          )
        if (this.polizasInfo !== null) {
          // CERRAR EL MENU CUANDO HACES CLICK
          if (this.$vuetify.breakpoint.smAndDown) {
            this.showMenu = !this.showMenu
          }
          // FOR AVOID ERROR IN REDUDANT PATH
          if (this.$route.path !== '/solicitudes') { this.$router.push('/solicitudes') }
        } else {
          this.$swal({
            title: 'Aviso',
            text: 'Estamos cargando sus datos para que pueda realizar sus solicitudes. Solos nos tomara unos segundos.',
            type: 'info',
            confirmButtonText: 'Entendido'
          })
        }
      },
      goToHelpCenter (evt) {
        this.resetTaggeoNps()
        // EVENT TRACK - Universal Analytics
        this.$gtm.trackEvent({
          event: 'virtualEvent',
          category: 'Zona Segura',
          action: 'Seleccionar menú - Centro Ayuda',
          label: 'Centro Ayuda'
        })
        // EVENT TRACK - GA4
        this.$gtm.trackEvent({
          event: 'select_button',
          'Nombre Sección': 'Zona Segura',
          TipoElemento: 'Botón',
          TipoAccion: 'Seleccionar menú - Centro Ayuda',
          CTA: 'Centro Ayuda'
        })
        var allElements = document.querySelectorAll('.inicio-main-content nav.menu a')
        for (var i = 0; i < allElements.length; i++) {
          allElements[i].classList.remove('active-menu')
        }
        if (evt.target.nodeName === 'A') {
          evt.target.classList.add('active-menu')
        } else {
          evt.target.parentElement.classList.add('active-menu')
        }
        // CERRAR EL MENU CUANDO HACES CLICK
        if (this.$vuetify.breakpoint.smAndDown) {
          this.showMenu = !this.showMenu
        }
        // TRACK EVENT - AMPLITUDE
        this.$amplitude.getInstance()
          .logEvent(
            this.amplitude.events.funcionalitySelected,
            {
              'Funcionalidad': this.amplitude.properties.helpCenter
            }
          )
        if (this.$route.path !== '/help-center') { this.$router.push('/help-center') }
      },
      goToVivemas (evt) {
        this.resetTaggeoNps()
        // EVENT TRACK - Universal Analytics
        this.$gtm.trackEvent({
          event: 'virtualEvent',
          category: 'Zona Segura',
          action: 'Seleccionar menú - Vive +',
          label: 'Vive +'
        })
        // EVENT TRACK - GA4
        this.$gtm.trackEvent({
          event: 'select_button',
          'Nombre Sección': 'Zona Segura',
          TipoElemento: 'Botón',
          TipoAccion: 'Seleccionar menú - Vive +',
          CTA: 'Vive +'
        })
  
        var allElements = document.querySelectorAll('.inicio-main-content nav.menu a')
        for (var i = 0; i < allElements.length; i++) {
          allElements[i].classList.remove('active-menu')
        }
        if (evt.target.nodeName === 'A') {
          evt.target.classList.add('active-menu')
        } else {
          evt.target.parentElement.classList.add('active-menu')
        }
        // CERRAR EL MENU CUANDO HACES CLICK
        if (this.$vuetify.breakpoint.smAndDown) {
          this.showMenu = !this.showMenu
        }
        this.$gtm.trackEvent({
          event: 'virtualPageView',
          pageTitle: 'Vive+',
          pageUrl: '/zonaprivada/vivemas-beneficios'
        })
        // TRACK EVENT - AMPLITUDE
        this.$amplitude.getInstance()
          .logEvent(
            this.amplitude.events.funcionalitySelected,
            {
              'Funcionalidad': this.amplitude.properties.vivemas
            }
          )
        // FOR AVOID ERROR IN REDUDANT PATH
        if (this.$route.path !== '/vivemas') { this.$router.push('/vivemas-beneficios') }
      },
      goToContactUs (evt) {
        evt.preventDefault()
        let url = 'https://www.interseguro.pe/ayuda/contactanos'
        /**
         * Redirección con valores hardcodeados
         */
        window.open(url, '_blank')
      },
      clearFnInterval () {
        clearInterval(this.interval)
      },
      logout(evt) {
        evt.preventDefault();
        sessionStorage.removeItem('infoPoliza');
        this.resetTaggeoNps();

        // Track events...
        this.$gtm.trackEvent({
          event: 'virtualEvent',
          category: 'Zona Segura',
          action: 'Seleccionar menú - Cerrar sesión',
          label: 'Cerrar sesión'
        });

        this.$gtm.trackEvent({
          event: 'select_button',
          'Nombre Sección': 'Zona Segura',
          TipoElemento: 'Botón',
          TipoAccion: 'Seleccionar menú - Cerrar sesión',
          CTA: 'Cerrar sesión'
        });

        clearInterval(this.interval);
        this.loader = true;

        // Cadena de promesas
        Promise.all([
          this.setEstadoPrestamo({
            codigoUsuario: this.userInfo.codigoUsuario,
            flag: false
          }),
        ])
          .catch(error => {
            console.error('Error durante el logout:', error);
            // Opcionalmente mostrar mensaje de error al usuario
            this.$swal({
              title: 'Error',
              text: 'Hubo un problema al cerrar sesión. Por favor intente nuevamente.',
              type: 'error'
            });
          })
          .finally(() => {
            this.loader = false;
            this.inactiveJwtLogout().then(() => {
              // Limpiar localStorage
              ['jwt', 'selPol', 'products', 'outoftime'].forEach(key =>
                localStorage.removeItem(key)
              );

              // Limpiar state de Vuex
              Object.keys(this.$store.state.user).forEach(key => {
                this.$store.state.user[key] = null;
              });

              // Navegar al login
              this.$router.push('/');
            })
          });
      }
    },
    created () {
      var self = this
      /** CLEAR INTERVAL */
      this.$root.$on('clearAllIntervals', function (obj) {
        self.clearFnInterval()
      })
      this.$root.$on('selectItemMenu', function (obj) {
        var allElements = document.querySelectorAll('.inicio-main-content nav.menu a')
        for (var i = 0; i < allElements.length; i++) {
          allElements[i].classList.remove('active-menu')
        }
        allElements[obj.position].classList.add('active-menu')
      })
      this.interval = setInterval(function () {
        self.$store.dispatch('user/tmpCheckJWT')
          .then(res => {
            if (res.data.codigoRespuesta !== '01') {
              self.clearFnInterval()
            }
          })
          .catch(() => { self.clearFnInterval() })
      }, 120000)
      // EVENTS FOR AVAILABLE EN MENU
      this.$root.$on('isAvailableForMakePayments', function (obj) {
        self.flags.isAvailableForPayments = true
      })
      this.$root.$on('isAvailableForMakeLoans', function (obj) {
        self.flags.isAvailableForLoans = true
      })
      this.$root.$on('isNotAvailableForRequirements', function (obj) {
        self.flags.isOnlySOAT = true
      })
      this.$root.$on('isAvailableForHelpCenter', function (bool) {
        self.showHelpCenter = true
      })
    },
    computed: {
      ...mapGetters('user', ['exp', 'userInfo', 'polizasInfo', 'viveMasEnabled', 'prestamosVidaHabilitado', 'tieneSolicitudPrestamoVidaEnEvaluacion']),
      /**
       * Determina si debe mostrar la opción Vive+ en el menú
       * El flag del backend SOLO afecta a usuarios con TODAS las pólizas RPP
       * @returns {boolean} true si debe mostrar, false si TODAS las pólizas son RPP y el flag está deshabilitado
       */
      shouldShowViveMas() {
        // 1. Sin pólizas → SIEMPRE mostrar (comportamiento original)
        if (!this.polizasInfo || this.polizasInfo.length === 0) {
          return true
        }

        // 2. Verificar si TODAS son RPP
        const todasSonRPP = this.polizasInfo.every(poliza => poliza.codigoProducto === 'RPP')

        // 3. Si tiene AL MENOS 1 póliza NO-RPP → SIEMPRE mostrar (ignora flag)
        if (!todasSonRPP) {
          return true
        }

        // 4. Si TODAS son RPP → el flag controla la visibilidad
        return this.viveMasEnabled
      }
    },
    mounted () {
      let self = this
      self.$amplitude.getInstance().identify(new this.$amplitude.Identify())
      if (self.$vuetify.breakpoint.smAndDown) {
        self.showMenu = false
      } else {
        self.showMenu = true
        var elmenu = document.getElementsByClassName('menu')[0]
        var childrensA = elmenu.getElementsByTagName('a')
        elmenu.addEventListener('mouseenter', function () {
          var windowWidth = window.innerWidth
          if (windowWidth < 1410) {
            elmenu.style = 'width: 130px !important'
          } else {
            elmenu.style = 'width: 150px !important'
          }
          for (var i = 0; i < childrensA.length; i++) {
            childrensA[i].style = 'flex-direction: initial; justify-content: flex-start; padding-left: 9%;'
            childrensA[i].getElementsByTagName('svg')[0].style = 'margin-right: 7px'
          }
        })
        elmenu.addEventListener('mouseleave', function () {
          var windowWidth = window.innerWidth
            if (windowWidth < 1365) {
              elmenu.style = 'width: 90px !important'
            } else {
              elmenu.style = 'width: 110px !important'
            }
          for (var i = 0; i < childrensA.length; i++) {
            childrensA[i].style = ''
            childrensA[i].getElementsByTagName('svg')[0].style = ''
          }
        })
      }
  
      this.$store.dispatch('nps/updateEventLogNps', {
        tipoDocumento: this.$store.state.user.info.tipoDocumento,
        numeroDocumento: this.$store.state.user.info.numeroDocumento
      })
    },
    beforeDestroy: function () {
      clearInterval(this.interval)
    },
    components: {
      Profile,
      PopupNps,
      PopupSolicitudEnCurso
    }
  }
  </script>
  
  <style>
    @import url("../assets/css/general.css");
  
    .inicio, .inicio-vivemas {
      background: white;
    }
    .inicio header,
    .inicio-vivemas header {
      background: #0855C4;
      height: 61px;
      z-index: 1;
    }
    .inicio header .container,
    .inicio-vivemas header .container {
      align-items: center;
      display: flex;
      justify-content: space-between;
      height: 100%;
      padding: 0!important;
    }
    .inicio-vivemas .landing .modal-category .list-category {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 7px;
    }
    .inicio-logo{
      width: 205px;
      display: flex;
    }
    .menu {
      background: white;
      z-index: 9;
    }
    .menu a {
      align-items: center;
      position: relative;
      flex-direction: column;
      padding-top: 9px;
    }
    .hide {
      display: none;
    }
    .inicio-search{
      align-items: center;
      background: white;
      border-radius: 23px;
      display: flex;
      height: 35px;
      position: relative;
      width: 266px;
    }
    .inicio-search svg{
      margin-left: 7px;
    }
    .inicio-search input[type="text"]{
      height: 30px;
      outline: none;
      font-size: 16px;
      margin-left: 12px;
      width: 169px;
    }
    .inicio-notificacion{
      align-items: center;
      background: white;
      border-radius: 50%;
      display: flex;
      height: 33px;
      justify-content: center;
      width: 33px;
    }
    .inicio main .container{
      padding: 0!important;
    }
  
    .inicio-panel{
      background: #FFFFFF;
      border: 1.59px solid #F2F2F2;
      padding-bottom: 22px;
      padding-top: 15px;
    }
    .inicio-panel h1{
      color: var(--text-color);
      font-weight: 500;
      margin-bottom: 15px;
    }
    .inicio-panel-block-1 h2,
    .inicio-panel-block-2 h2{
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 2px;
    }
    .inicio-panel-block-1-btn{
      align-items: center;
      background: white;
      border: 1.59px solid #F2F2F2;
      box-shadow: 0px 2.89px 2.89px rgba(112, 112, 112, 0.25);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      height: 37px;
      width: 37px;
    }
  
    .inicio-panel-banner{
      align-items: center;
      background-color: #0855C4;
      border-radius: 16px;
      display: flex;
    }
    .inicio-panel-banner h3,
    .inicio-panel-banner p{
      color: white;
    }
    .inicio-panel-banner h3{
      font-weight: 500;
      font-size: 16px;
      margin-bottom: 10px;
    }
    .inicio-panel-banner p{
      font-size: 14px;
      margin-bottom: 0!important;
    }
    .inicio-panel-banner button{
      align-items: center;
      background: var(--fuchsia-color);
      border-radius: 4px;
      display: flex;
      color: white;
      font-family: "Omnes Regular", sans-serif;
      font-weight: 500px;
      font-size: 16px;
      justify-content: center;
      height: 29px;
      width: 190px;
    }
    .inicio-panel-block-1-descrip{
      margin-left: auto;
      margin-right: auto;
      width: 80%;
    }
    .inicio-panel-block-1-descrip svg{
      margin: 2px 0px 0 5px;
    }
  
    /* .inicio-panel-pagos-list{
      display: flex;
      flex-wrap: wrap;
    } */
    .inicio-panel-pagos article{
      padding-top: 30px;
    }
    .inicio-panel-pagos article p{
      margin-bottom: 0;
    }
    .inicio-panel-pagos article h3{
      color: var(--text-color);
      font-size: 16px;
      font-weight: 500;
    }
    .inicio-panel-pagos article,
    .inicio-panel-contacto article{
      background: #FFFFFF;
      border: 1.67837px solid #F2F2F2;
      box-sizing: border-box;
      box-shadow: 0px 3.05063px 6px rgba(159, 159, 159, 0.16);
      border-radius: 16.8893px;
      margin-top: 10px;
      height: 99px;
      width: 260px;
    }
    .inicio-panel-contacto article{
      padding-top: 5px;
    }
    .inicio-panel-contacto article .g-flex{
      margin-top: 15px;
      margin-left: 23px;
    }
    .inicio-panel-contacto article a{
      color: #0855C4;
      margin-left: 13px;
    }
    .inicio-extra{
      background: white;
      padding-left: 2%;
      padding-right: 1.5%;
    }
    .inicio-extra-item-title{
      margin-bottom: 10px;
      margin-top:10px;
    }
  
    .inicio-extra-item-title p{
       color: var(--text-color);
       font-size: 14px;
    }
    .inicio-extra-item-title p:nth-of-type(2){
      margin-left: 5px;
    }
  
    .inicio-extra-item-porcent p{
      color: #0855C4;
      font-size:12px;
    }
    .inicio-extra-item-porcent p:nth-of-type(1){
      text-align: right;
    }
  
    .inicio-extra-item-porcent div,
    .inicio-extra-item-porcent aside{
      border-radius: 8px;
      height: 6px;
    }
  
    .inicio-extra-item-porcent div{
      background: #D9D9D9;
      margin-bottom: 10px;
      margin-top: 5px;
      position:relative;
      max-width: 260px;
      z-index: 2;
    }
  
    .inicio-extra-item-porcent aside{
       background: #0855C4;
       left:0;
       position:absolute;
       top:0;
       z-index: 5;
    }
    .inicio-extra-item-fecha{
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
    .inicio-extra-item-fecha p{
      color: #919191;
      font-size: 14px;
      margin-left: 7px;
    }
    .title-name {
      color: var(--first-brand-color);
      font-size: 20px;
      text-transform: capitalize;
    }
  
    @media screen and (max-width: 1023px){
      .menu {
        left: 0;
        height: calc(100% - 130px);
        position: fixed;
        top: 77px;
        width: 100%;
        z-index: 90;
      }
      .menu a {
        border-bottom: 1.46469px solid #C4C4C4;
        height: 50px;
        /** LAS 3 LINEAS SGTES ES LO NUEVO */
        flex-direction: initial;
        padding-top: 0;
        padding-left: 5%;
      }
      /* ORIGINAL - POR SI CAMBIAN DE OPINION EN EL MENU MOBILE
      .menu .active-menu:before,
      .menu .active-menu-stroke:before{
        background: #0855C4;
        content: '';
        left: 0;
        height: 50px;
        position: absolute;
        top: -1px;
        width: 100%;
        z-index: 1;
      }
      */
      .menu .active-menu:before,
      .menu .active-menu-stroke:before {
        background: #0855C4;
        content: '';
        left: 0;
        height: 41px;
        position: absolute;
        top: 4px;
        z-index: 1;
        width: 60%;
        border-radius: 0px 25px 25px 0px;
      }
      /** ESTO ES NUEVO, SOLO LA SGTE REGLA CSS */
      .menu a span {
        margin-left: 7px;
      }
      .menu .active-menu svg path {
        fill: white;
      }
      .menu .active-menu-stroke svg path {
        fill: white;
        stroke: white;
      }
      .menu .active-menu-stroke span,
      .menu .active-menu span {
        color: white;
      }
      .menu .active-menu-stroke svg,
      .menu .active-menu-stroke span,
      .menu .active-menu svg,
      .menu .active-menu span {
        z-index: 10;
      }
      .menu a:nth-of-type(1) {
        border-top: 1.46469px solid #C4C4C4;
      }
      .inicio-search {
        display: none;
      }
      .inicio header,
      .inicio-vivemas header {
        position: fixed;
        height: 77px!important;
        display: flex;
        align-items: center;
        padding: 0 20px;
        top: 0;
        width: 100%;
      }
      .inicio-vivemas .landing {
        margin-top: 75px;
        margin-bottom: 50px;
      }
      .inicio-footer {
        align-items: center;
        background: white;
        bottom: 0;
        height: fit-content;
        left: 0;
        position: fixed;
        width: 100%;
        z-index: 90;
        border-top: 1px solid #919191;
      }
      .inicio-footer article {
        cursor: pointer;
        position: relative;
        text-align: center;
        z-index: 99;
      }
      .inicio-footer article div {
        /* align-items: center; */
        align-items: flex-end;
        display: flex;
        justify-content: center;
        height: 35px;
      }
      .inicio-footer article p {
        -webkit-transition: all 0.3s;
        -moz-transition: all 0.3s;
        -o-transition: all 0.3s;
        -ms-transition: all 0.3s;
        transition: all 0.3s;
      }
      .inicio-footer article div svg path{
        -webkit-transition: all 0.3s;
        -moz-transition: all 0.3s;
        -o-transition: all 0.3s;
        -ms-transition: all 0.3s;
        transition: all 0.3s;
      }
  
      .active-mas-mobile svg circle{
        stroke: #0855C4;
      }
      .active-perfil-mobile svg path,
      .active-inicio-mobile svg path{
        fill: #0855C4;
      }
      .active-perfil-mobile p,
      .active-inicio-mobile p,
      .active-mas-mobile p{
        color: #0855C4;
      }
      .inicio-main-dash {
        margin: 77px auto 70px;
        max-width: 405px;
      }
      .inicio-panel-content{
        margin:auto;
        width: 90%;
      }
      .inicio-panel-banner{
        padding-bottom: 30px;
        padding-top: 35px;
      }
      .inicio-panel-banner figure{
        margin: auto;
      }
      .inicio-panel-banner img{
        max-width: 100%;
      }
      .inicio-panel-banner article{
        margin-left: 5px;
  
      }
      .inicio-panel-banner article p {
        padding-right: 15px;
      }
      .inicio-panel-banner button{
        margin-top: 15px;
      }
      .inicio-extra{
        margin: auto;
        padding-bottom: 12px;
        width: 90%;
      }
      .inicio-panel-block-1-list article{
        align-items: center;
        display: flex;
        padding-left: 15px;
        width: 100%;
      }
      .inicio-panel-block-1-list article h3{
        margin-bottom: 5px;
  
      }
      .inicio-panel-block-1-list figure{
        margin-bottom: 0;
        padding-top: 10px;
        height: auto;
        width: 27%;
      }
      .inicio-panel-block-1-list article:not(:nth-of-type(1)){
        margin-top: 20px;
      }
      .inicio-panel-block-1-descrip{
        margin-left: 15px;
        width: 50%;
      }
      .inicio-panel-pagos-list article,
      .inicio-panel-contacto article{
        width: 100%;
      }
      .inicio-panel-pagos-list .g-flex figure{
        text-align: center;
        width: 93px;
      }
  
      .inicio-panel-block-1-btn{
        margin: 15px auto 0 auto;
      }
    }
    @media screen and (min-width: 1024px) {
      .inicio {
        background: #F8F8F8;
        height: 100%;
      }
      .menu {
        min-height: calc(100vh - 61px);
        text-align: center;
        position: absolute;
        border-right: 1px solid rgb(159 159 159 / 16%);
        box-shadow: 0px 16px 10px 0px rgb(0 0 0 / 14%), 0px 11px 18px 0px rgb(0 0 0 / 12%), 0px 13px 5px -1px rgb(0 0 0 / 20%)
      }
      .menu a {
        align-items: center;
        justify-content: center;
        border-bottom: 1.46469px solid #C4C4C4;
        /* transition: all 0.3s;*/
        width: 100%;
      }
      /*
      .menu a span {
        transition: all 0.3s;
        display: none;
      }
      */
      .menu a:hover {
        /* flex-direction: initial; */
        transition: all 0.3s;
      }
      .menu a:hover svg {
        /* margin-right: 7px; */
        transition: all 0.3s;
      }
      .menu:hover {
        /* width: 150px; */
        transition: all 0.3s;
      }
      .menu:not(:hover) {
        width: 110px;
        transition: all 0.3s;
      }
      .menu-separator {
        width: 110px;
      }
      .menu a:hover span {
        color: #FFF;
      }
      .menu a.active-menu {
        background: #0855C4;
        content: '';
        left: 0;
        width: 100%;
        z-index: 1;
      }
      /*
      .menu a.active-menu:hover span{
        display: none;
      }
      */
      .menu a.active-menu svg path {
        fill: #FFF;
      }
      .menu a.active-menu span {
        color: #FFF;
      }
      .menu a:hover {
        background: #0855C4;
      }
      /*
      .menu a:hover span {
        color: #FFF;
      }
      */
      .menu a:hover svg path {
        fill: white;
      }
      .menu .box-menu-home-seguros:hover svg path {
        stroke-width: 0.8 !important;
        fill: #0855C4 !important;
        stroke: #ffffff !important;
      }
      .menu .box-menu-home:hover svg path {
        fill: #0855C4 !important;
        stroke: #ffffff !important;
      }
  
      .menu a:nth-of-type(1) {
        height: 70px;
        padding-bottom: 7px;
        padding-top: 20px;
      }
      .menu a.active-menu:nth-of-type(1) {
        border-top: 1.46469px solid #C4C4C4;
      }
      .menu a:not(:nth-of-type(1)) {
        height: 75px;
      }
      .inicio-main-content {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        position: relative;
        /* margin-left: auto;
        margin-right: auto;
        max-width: 1355px; */
      }
      .inicio-main-dash {
        display: flex;
        justify-content: space-between;
        width: calc(100% - 110px);
        height: calc(100vh - 61px);
        overflow: auto;
      }
      .inicio-panel {
        box-shadow: 0px 3.05063px 6px rgba(159, 159, 159, 0.16);
        margin-left: auto;
        margin-right: auto;
        max-width: 955px;
      }
      .inicio-panel h1 {
        font-size: 24px;
        margin-top: 3px;
      }
      .inicio-panel-content {
        margin-left: 30px;
        margin-right: 30px;
      }
      .inicio-panel-banner {
        justify-content: space-between;
        padding-left: 50px;
        padding-right: 50px;
      }
      .inicio-panel-banner button {
        height: 39px;
        width: 110px;
      }
      .inicio-panel-banner div {
        margin-right: 70px;
        text-align: center;
      }
      .inicio-panel-banner h3 {
        font-size: 23.3px;
      }
      .inicio-panel-banner p {
        font-size: 18px;
      }
      .inicio-panel-banner article {
        align-items: center;
        display: flex;
      }
      .inicio-panel-block-1-list {
        position: relative;
      }
      .inicio-panel-block-1-btn {
        top: 50%;
        transform: translateY(-50%);
        position: absolute;
        right: -15px;
      }
  
      .inicio-panel-block-1-list article h3 {
        text-align: center;
      }
      .inicio-panel-block-1-list article:not(:nth-of-type(1)) {
        margin-left: 17px;
      }
      .inicio-panel-block-2 {
        align-items: flex-end;
        display: flex;
        justify-content: space-between;
      }
      .inicio-panel-pagos-list article:not(:nth-of-type(1)) {
        margin-left: 22px;
      }
      .inicio-panel-contacto {
        margin-left: 15px;
      }
  
      .box-main-header-formatter{
        position: fixed;
        top: 0;
        left: 0;
        /* z-index: 999 !important; */
        width: 100%;
      }
      .box-inicio-main-formatter{
        position: absolute;
        top: 61px;
        max-width: 100%;
        width: 100%;
        min-height: calc(100vh - 61px);
      }
      .box-inicio-main-formatter > .box-menu-formatter{
        position: fixed;
      }
      .box-menu-formatter .g-flex {
        padding-top: 5px !important;
        padding-bottom: 0px !important;
        height: 4.6em !important;
      }
      .box-menu-formatter .g-flex svg{
        height: 20px !important;
      }
      .box-menu-formatter .g-flex span{
        font-size: 12px !important;
      }
      .border-radius-top {
        border-radius: 16px 16px 0 0 !important;
      }
      .panel-full-height {
        min-height: calc(100vh - 77px) !important;
      }
      .title-name {
        font-size: 18px;
      }
    }
    /** PARA PANTALLA DESKTOP CHICAS */
    @media screen and (min-width: 1024px) and (max-width: 1364px) {
      .inicio-panel {
        min-width: 840px !important;
        width: 840px;
      }
      .menu {
        font-size: 12px;
      }
      .menu:not(:hover) {
        width: 90px;
      }
      .menu-separator {
        width: 90px;
      }
    }
    /* @media screen and (min-width: 1024px) and (max-width: 1330px) and (max-height: 725px){
      .menu{
        height: 115vh;
      }
    } */
    @media screen and (min-width: 1365px) {
      .box-menu-formatter .g-flex {
        height: 4.3em !important;
      }
      .box-menu-formatter .g-flex svg{
        height: 22px !important;
      }
    }
  </style>
  


// WEBPACK FOOTER //
// src/layouts/Protected.vue